import React from "react";

const TaskTitle = ({ task }) => {
    if (!task) {
        return null;
    }

    if (!task.assignable) {
        return task.title;
    }

    return <a href={task.url}>{task.title}</a>;
};

export default TaskTitle;
